<div class="modal-overlay" (mousedown)="closed.emit()">
  <div
    class="modal-card sk-catm"
    role="dialog"
    aria-modal="true"
    aria-labelledby="sk-catm-title"
    (mousedown)="$event.stopPropagation()"
    (keydown.escape)="closed.emit()"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <div class="modal-head">
      <div>
        <div class="modal-sub">
          {{ 'skillManagement.categories.sub' | translate }}
        </div>
        <div class="modal-title" id="sk-catm-title">
          {{ 'skillManagement.categories.title' | translate }}
        </div>
      </div>
      <button
        type="button"
        class="modal-x"
        (click)="closed.emit()"
        [attr.aria-label]="'general.close' | translate"
      >
        <app-skill-icon name="close" [size]="22" />
      </button>
    </div>

    <div class="modal-body">
      <p class="sk-catm__intro">
        {{ 'skillManagement.categories.intro' | translate }}
      </p>
      <div class="sk-catm__bar">
        <span class="sk-catm__count"
          >{{
            'skillManagement.categories.count'
              | translate: { count: rows.length }
          }}
          @if (missingEnCount > 0) {
            <span class="sk-noen">{{
              'skillManagement.categories.missingEn'
                | translate: { count: missingEnCount }
            }}</span>
          }
        </span>
        <button
          type="button"
          class="btn-text btn-text--accent sk-catm__add"
          (click)="addRow()"
        >
          <app-skill-icon name="plus" [size]="15" />{{
            'skillManagement.categories.add' | translate
          }}
        </button>
      </div>

      <div class="sk-catm__grid sk-catm__grid--head">
        <span
          ><span class="sk-lang">DE</span
          >{{ 'skillManagement.categories.colDe' | translate }}</span
        >
        <span
          ><span class="sk-lang">EN</span
          >{{ 'skillManagement.categories.colEn' | translate }}</span
        >
        <span class="sk-r">{{
          'skillManagement.categories.colSkills' | translate
        }}</span>
        <span></span>
      </div>

      @for (row of rows; track row.rowId) {
        <div class="sk-catm__grid sk-catm__row">
          <div class="sk-catm__cell">
            <input
              class="bf-input"
              lang="de"
              [maxlength]="limits.SHORT_LABEL"
              [(ngModel)]="row.de"
              [class.bf-input--invalid]="
                isMissing(row, row.de) || duplicateDeOf(row)
              "
              [attr.aria-invalid]="
                isMissing(row, row.de) || !!duplicateDeOf(row)
              "
              [placeholder]="
                'skillManagement.categories.placeholderDe' | translate
              "
              [attr.aria-label]="'skillManagement.categories.colDe' | translate"
            />
            @if (duplicateDeOf(row); as other) {
              <span class="sk-hint sk-hint--warn">{{
                'skillManagement.categories.duplicate'
                  | translate: { other: other }
              }}</span>
            } @else if (isRenamed(row)) {
              <span class="sk-hint">
                {{
                  (row.skillCount === 1
                    ? 'skillManagement.categories.renameOne'
                    : 'skillManagement.categories.rename'
                  ) | translate: { from: row.originalDe, count: row.skillCount }
                }}
              </span>
            }
          </div>
          <div class="sk-catm__cell">
            <input
              class="bf-input"
              lang="en"
              [maxlength]="limits.SHORT_LABEL"
              [(ngModel)]="row.en"
              [class.bf-input--invalid]="
                isMissing(row, row.en) || duplicateEnOf(row)
              "
              [attr.aria-invalid]="
                isMissing(row, row.en) || !!duplicateEnOf(row)
              "
              [placeholder]="
                'skillManagement.categories.placeholderEn' | translate
              "
              [attr.aria-label]="'skillManagement.categories.colEn' | translate"
            />
            @if (isMissing(row, row.en)) {
              <span class="sk-hint sk-hint--warn">{{
                'skillManagement.categories.required' | translate
              }}</span>
            } @else if (duplicateEnOf(row); as other) {
              <span class="sk-hint sk-hint--warn">{{
                'skillManagement.categories.duplicate'
                  | translate: { other: other }
              }}</span>
            }
          </div>
          <span class="sk-r sk-num sk-catm__n">{{ row.skillCount }}</span>
          <button
            type="button"
            class="of-del sk-catm__del"
            [disabled]="row.skillCount > 0"
            (click)="removeRow(row)"
            [title]="
              row.skillCount > 0
                ? ('skillManagement.categories.deleteBlocked'
                  | translate: { count: row.skillCount })
                : ('skillManagement.categories.delete' | translate)
            "
            [attr.aria-label]="
              row.skillCount > 0
                ? ('skillManagement.categories.deleteBlocked'
                  | translate: { count: row.skillCount })
                : ('skillManagement.categories.delete' | translate)
            "
          >
            <app-skill-icon name="trash" [size]="16" />
          </button>
        </div>
      }
    </div>

    <div class="modal-foot">
      <span class="modal-count">
        @if (!valid) {
          {{ 'skillManagement.categories.incomplete' | translate }}
        } @else if (missingEnCount === 0) {
          {{ 'skillManagement.categories.complete' | translate }}
        }
      </span>
      <div class="modal-actions">
        <button type="button" class="btn-text" (click)="closed.emit()">
          {{ 'general.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn-primary"
          [disabled]="!valid || saving"
          (click)="save()"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
